import React from 'react';
import cn from 'classnames';
import * as PropTypes from 'prop-types';

import Button from '../../Button';
import { IDS } from '../../../constants/ids';
import Popup from '../../common/Popup';
import { enhance } from './enhance';
import styles from './styles.styl';

function OverlapModal({
  isOpenOverlapModal,
  intl: { formatMessage },
  closeModal,
  initOverlap,
}) {
  const handleOverlap = () => {
    initOverlap();
    closeModal();
  };

  return (
    <Popup
      opened={isOpenOverlapModal}
      onClose={closeModal}
      withHeading={false}
      mobileFullScreen={false}
    >
      <div className={styles.content}>
        {formatMessage({ id: 'appointment.form.overlap' })}
      </div>
      <div className="mt3">
        <Button
          id={IDS.COMMON.ACTION_CONFIRMATION_SUBMIT}
          color="primary"
          onClick={handleOverlap}
          children={formatMessage({ id: 'common.overlap' })}
          type="button"
          className={cn('mr3', styles.btnOverlap)}
          raised
        />
        <Button
          id={IDS.COMMON.ACTION_CONFIRMATION_CANCEL}
          color="accent"
          raised
          type="button"
          onClick={closeModal}
          children={formatMessage({ id: 'common.cancel' })}
          className={styles.btnCancel}
        />
      </div>
    </Popup>
  );
}

OverlapModal.propTypes = {
  isOpenOverlapModal: PropTypes.bool,
  intl: PropTypes.object,
  closeModal: PropTypes.func,
  initOverlap: PropTypes.func,
};

export default enhance(OverlapModal);



// WEBPACK FOOTER //
// ./src/components/VirtualVisit/OverlapModal/index.jsx